module.exports = __webpack_public_path__ + "img/two-locks.62e89c8.svg";